const months = ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "września", "października", "listopada", "grudnia"];

export function dateToString(date) {
    const d = new Date(date*1000);

    return d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
}
